<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import {
		WSinit
	} from "@/utils/websocketMessageHandler.js";
	import {
		Getitem,
		Setitem
	} from "@/utils/item";
	import {
		workall
	} from "@/utils/request.js";



	export default {
		data() {
			return {
				userId: '',
				clientId: "cus",
			};
		},
		async created() {
			let worktype = Getitem('worktype')
			if (worktype && JSON.stringify(worktype) !== '{}' && worktype !== '') {
				let ver = worktype.ver
				let res = await workall(ver)
				if (res.code === 200) {
					if (res.data) {
						await Setitem('worktype', res.data)
					}
				}
			} else {
				let ver = -1
				let res = await workall(ver)
				if (res.code === 200) {
					await Setitem('worktype', res.data)
				}
			}


		},
		methods: {

		},
	};
</script>


<style lang="less">
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	nav {
		padding: 30px;

		a {
			font-weight: bold;
			color: #2c3e50;

			&.router-link-exact-active {
				color: #42b983;
			}
		}
	}

	html,
	body {
		margin: 0;
		font-size: 16px;
	}
</style>